import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, MenuItem,
  Menu,
  Stack, Button,
  InputBase, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown, Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { fomateDate } from '../../utils/fomateDate';
import { deleteCategoriesThunk, setEditCategory } from '../../redux/category/getAllCategorySlice';
import { Filter } from '../../Svg';
import { deletebomOrderThunk } from '../../redux/bomOrderSlice';
import { deletewizardOrderThunk } from '../../redux/wizardOrderSlice';


// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  borderBottom: '1px solid #E6E1E5',
  padding: '4px 40px',
  fontSize: '14px',
  color: '#667085',
}));

const SearchInput = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  width: '320px',
  fontFamily: `'Public Sans', sans-serif`,
}));
const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Cancelled = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: 'red',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));


const Processing = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#F86624',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EAF8FF',
  color: '#2BB2FE',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));






const AllWizardOrderTable = ({ bomData, page, setPage, itemsPerPage, start, end, totalItems,selectedTab }) => {



  const [anchorEl, setAnchorEl] = useState(null);
  const [activeColumn, setActiveColumn] = useState(null);
  const [selectedId, setSelectedId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);




  const dispatch = useDispatch()
  const navigate = useNavigate()




  //delete
  const deleteCategory = () => {
    dispatch(deletewizardOrderThunk(selectedId))
    setIsModalOpen(false);

  }


  //delete modal open
  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };
  const handleOpenMenu = (event, column) => {
    setAnchorEl(event.currentTarget);
    setActiveColumn(column);
  };


  return (
    <>


      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell>
                Order ID
                <IconButton onClick={(e) => handleOpenMenu(e, 'Products')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>


              <HeaderCell>
                Products
                <IconButton onClick={(e) => handleOpenMenu(e, 'Products')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Date
                <IconButton onClick={(e) => handleOpenMenu(e, 'Category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Customer
                <IconButton onClick={(e) => handleOpenMenu(e, 'Products')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>



              <HeaderCell>
                Total
                <IconButton onClick={(e) => handleOpenMenu(e, 'Category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              {/* <HeaderCell>
                Payment
                <IconButton onClick={(e) => handleOpenMenu(e, 'Category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell> */}

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu(e, 'Status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {bomData?.map((row) => (
              <TableRow key={row._id}>

                <ProductText sx={{ width: '13%' }}>{row._id}</ProductText>

                

                <ProductText sx={{ width: '12%' }}>{row?.productCount} products</ProductText>

                <ProductText sx={{ width: '12%' }}>{fomateDate(row.createdAt)}</ProductText>


                <TableCells sx={{
                  width: '10%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row?.user?.companyName}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row?.user?.fullName}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <TableCells sx={{ width: '12%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {row?.total}
                </TableCells>

             


                <TableCells sx={{ width: '11%' }}>
                  {row?.status === "NEW" ? (
                    <New label="New" size="small" />
                  ) : row?.status === "DELIVERED" ? (
                    <Delivered label="Delivered" size="small" />
                  ) : row?.status === "PROCESSING" ? (
                    <Processing label="Processing" size="small" />
                  ) : row?.status === "CANCELLED" ? (
                    <Cancelled label="Cancelled" size="small" />
                  ) : (
                    <Shiped label="Shipped" size="small" />
                  )}
                </TableCells>


                <Operations sx={{ width: '8% !important' }}
                  TableCells={TableCells}
                  viewClick={() => navigate(`/wizard/wizardOrderDetails/${row?._id}`)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  selectedTab={1}
                  />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'category'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllWizardOrderTable;
